export default __webpack_public_path__ + "static/media/mobile-1.2b465630.png";